// @ts-nocheck
import Page from "@insite/mobius/Page";
import { pageStyles } from "@store/Themes/common/mixins/page";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(Page.defaultProps, {
    padding: 0,
    fullWidth: [true, true, true, true, true],
    css: css`
        ${pageStyles()};
    `,
});
